import React, { useState } from 'react';
import { getAuth, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

import SearchModal from './components/ModalSearch';
import Help from './components/DropdownHelp';
import UserMenu from './components/DropdownProfile';

function Header({
  sidebarOpen,
  setSidebarOpen,
  variant = 'default',
}) {

  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const auth = getAuth(); // Initialize auth (for Firebase)
  const navigate = useNavigate();

  // Function to handle signout
  const handleSignOut = () => {
    signOut(auth).then(() => {
      navigate('/login');
    }).catch((error) => {
      console.error('Signout error', error);
    });
  };

  return (
    <header className="sticky top-0 z-30" style={{
      fontFamily: '"Share Tech Mono", monospace',
      background: 'linear-gradient(135deg, rgba(44, 62, 80, 0.98), rgba(52, 73, 94, 0.98))',
      borderBottom: '3px solid rgba(241, 196, 15, 0.5)',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.4)'
    }}>
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">

          {/* Header: Left side */}
          <div className="flex items-center">
            {/* Hamburger button */}
            <button
              className="lg:hidden p-2.5 rounded-lg transition-all duration-200 font-bold"
              style={{
                color: '#F1C40F',
                background: 'linear-gradient(135deg, rgba(52, 73, 94, 0.8), rgba(44, 62, 80, 0.8))',
                textShadow: '0 0 8px rgba(241, 196, 15, 0.5)'
              }}
              aria-controls="sidebar"
              aria-expanded={sidebarOpen}
              onClick={(e) => { e.stopPropagation(); setSidebarOpen(!sidebarOpen); }}
              onMouseEnter={(e) => {
                e.target.style.background = 'linear-gradient(135deg, #F1C40F, #F39C12)';
                e.target.style.color = '#2C3E50';
                e.target.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'linear-gradient(135deg, rgba(52, 73, 94, 0.8), rgba(44, 62, 80, 0.8))';
                e.target.style.color = '#F1C40F';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              <span className="sr-only">Open sidebar</span>
              <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="5" width="16" height="2" rx="1" />
                <rect x="4" y="11" width="16" height="2" rx="1" />
                <rect x="4" y="17" width="16" height="2" rx="1" />
              </svg>
            </button>
          </div>

          {/* Header: Right side */}
          <div className="flex items-center space-x-2">
            {/* Search Button */}
            <div>
              <button
                className="w-11 h-11 flex items-center justify-center rounded-lg transition-all duration-200 font-bold"
                style={{
                  background: 'linear-gradient(135deg, rgba(52, 73, 94, 0.8), rgba(44, 62, 80, 0.8))',
                  color: '#F1C40F',
                  textShadow: '0 0 8px rgba(241, 196, 15, 0.5)'
                }}
                onClick={(e) => { e.stopPropagation(); setSearchModalOpen(true); }}
                aria-controls="search-modal"
              >
                <span className="sr-only">Search</span>
                <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21.71 20.29L18 16.61A9 9 0 1 0 16.61 18l3.68 3.68a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.39zM11 18a7 7 0 1 1 7-7 7 7 0 0 1-7 7z"/>
                </svg>
              </button>
              <SearchModal id="search-modal" searchId="search" modalOpen={searchModalOpen} setModalOpen={setSearchModalOpen} />
            </div>
         
            <Help align="right" />
            
            {/* Divider */}
            <div className="w-0.5 h-8 rounded-full" style={{
              background: 'linear-gradient(to bottom, transparent, rgba(241, 196, 15, 0.6), transparent)'
            }}></div>
            
            <UserMenu align="right" handleSignOut={handleSignOut} />
          </div>

        </div>
      </div>
    </header>
  );
}

export default Header;
